import { useEffect } from "react";
import { Blocker, BlockerFunction, useBlocker } from "react-router-dom";

function usePrompt(when: boolean | BlockerFunction, disabled = false): Blocker {
	const blocker = useBlocker(disabled ? false : when);
	useEffect(() => {
		if (blocker.state === "blocked" && !when && !disabled) {
			blocker.reset();
		}
	}, [blocker, when, disabled]);

	//keeping this for when we combine all of the functionality into our own internal modal
	/*useBeforeUnload(
		useCallback(
			(event) => {
				if (
					(typeof when === "boolean" && when === true) ||
					// @ts-expect-error Reload case -- No location present
					(typeof when === "function" && when())
				) {
					event.preventDefault();
					// eslint-disable-next-line no-param-reassign
					event.returnValue = message;
				}
			},
			[when]
		),
		{ capture: true }
	);*/

	return blocker;
}

export default usePrompt;
